export const PL_TIMEZONE = 'Europe/Warsaw';